var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadChallanAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7749_144409)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 26,
    height: 26,
    rx: 4,
    fill: "#155096"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8873 14.1992L11.9228 14.0354C11.786 14.0122 11.6448 14 11.5 14C10.1193 14 9 15.1193 9 16.5C9 17.8807 10.1193 19 11.5 19H21.5C22.3284 19 23 18.3284 23 17.5C23 16.7529 22.4528 16.1317 21.7374 16.0185L20.6993 15.8544L20.9149 14.8257C20.9706 14.5601 21 14.284 21 14C21 11.7909 19.2091 10 17 10C15.052 10 13.4272 11.3935 13.0722 13.2385L12.8873 14.1992ZM21.971 14.5414C21.9902 14.3636 22 14.1829 22 14C22 11.2386 19.7614 9 17 9C14.5636 9 12.5342 10.7427 12.0902 13.0496C11.8983 13.017 11.7012 13 11.5 13C9.567 13 8 14.567 8 16.5C8 18.433 9.567 20 11.5 20H21.5C22.8807 20 24 18.8807 24 17.5C24 16.339 23.2086 15.3628 22.1358 15.0816C22.0566 15.0608 21.9758 15.0438 21.8936 15.0308C21.9273 14.8704 21.9532 14.7071 21.971 14.5414Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3536 12.1464C17.1583 11.9512 16.8417 11.9512 16.6464 12.1464L14.6464 14.1464C14.4512 14.3417 14.4512 14.6583 14.6464 14.8536C14.8417 15.0488 15.1583 15.0488 15.3536 14.8536L16.5 13.7071L16.5 17.5C16.5 17.7761 16.7239 18 17 18C17.2761 18 17.5 17.7761 17.5 17.5L17.5 13.7071L18.6464 14.8536C18.8417 15.0488 19.1583 15.0488 19.3536 14.8536C19.5488 14.6583 19.5488 14.3417 19.3536 14.1464L17.3536 12.1464Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7749_144409",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7749_144409"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7749_144409",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadChallanAction);
export default __webpack_public_path__ + "static/media/upload-challan-action.65c238fb68670c61fb10e4d1dd2f9a33.svg";
export { ForwardRef as ReactComponent };